import React, { useEffect, useReducer } from 'react'
import { Link } from 'react-router-dom'
import { ProductReducer, ACTION_TYPES, Products } from '../../reducer'

function ProductManager() {
    const [state, dispatch] = useReducer(ProductReducer, Products)

    useEffect(() => {
        const fecthData = async () => {
            dispatch({type: ACTION_TYPES.FETCH_START})
            try {
                const response = await fetch('https://6cbl05gmqj.execute-api.us-east-1.amazonaws.com/api/v1/products')
                if (!response.ok)
                    throw new Error(`Error: ${response.statusText}`)
                const data = await response.json()
                dispatch({type:ACTION_TYPES.FETCH_SUCCESS, payload:data.response})
            }catch(err){
                dispatch({type:ACTION_TYPES.FETCH_ERROR, payload:err.message})
            }
        }
        fecthData()
    },[])
  return (
    <>
        <div class="profile-header">
            <div class="profile-header-inner">
                <div class="profile-avatar">
                    <img class="avatar" src="https://via.placeholder.com/250x250" alt="" data-demo-src="./../assets/img/avatars/helen.jpg" />
                    <h2 class="title is-4 is-narrow">Helen Miller</h2>
                    <p class="subtitle is-6">Administrator</p>
                </div>

                <div class="tabs is-centered">
                    <ul>
                        <li class="is-active"><Link to="/admin/product-management">Products</Link></li>
                        <li><a href="/admin/add-new-product">Create New</a></li>
                        {/* <li><a href="profile-3.html">Network</a></li> */}
                    </ul>
                </div>
            </div>
        </div>
        <div class="section is-app-grey">
            <div class="container">
                <div class="profile-wrapper">
                    <div class="profile-card">
                        <div class="profile-card-head">
                            <h3>All Products</h3>
                        </div>
                        <div class="column is-12 is-offset-0">
                            <table class="table is-bordered">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Product</th>
                                        <th>Category</th>
                                        <th>Price</th>
                                        <th>Display Image</th>
                                        <th>Manage</th>
                                    </tr>
                                </thead>
                                {state.loading && <center><p>Loading...</p></center>}
                                <tbody>
                                    {state.data?.map((product, index) => (
                                        <tr>
                                            <td>{index+1}</td>
                                            <td>{product.name}</td>
                                            <td>{product.category}</td>
                                            <td>{product.price}</td>
                                            <td><center><img src={product.featured} width="30" height="20" /></center></td>
                                            <td>
                                                <a href={"/admin/manage-product/"+product.slug} class="button is-small btn-align accent-btn raised rounded btn-outlined">
                                                    Manage
                                                </a>
                                            </td>
                                        </tr>
                                    ))}                                    
                                </tbody>
                            </table>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default ProductManager
